"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var Rails_1 = require("../../utils/Rails");
var constants_1 = require("./constants");
var reducer_1 = __importDefault(require("./reducer"));
exports.rails = (_a = Rails_1.createRailsSelectors(constants_1.namespace, reducer_1.default), _a.rails), exports.rail = _a.rail, exports.isLoading = _a.isLoading, exports.error = _a.error, exports.railsShallow = _a.railsShallow, exports.continueWatchingRailId = _a.continueWatchingRailId;
//# sourceMappingURL=selectors.js.map